<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33301 14C1.33295 12.9735 1.6291 11.9689 2.1859 11.1066C2.74271 10.2443 3.53652 9.56095 4.47207 9.13865C5.40762 8.71634 6.44517 8.57297 7.46018 8.72575C8.4752 8.87854 9.42456 9.32097 10.1943 9.99997M10.6663 12.6667L11.9997 14L14.6663 11.3333M9.99967 5.33333C9.99967 7.17428 8.50729 8.66667 6.66634 8.66667C4.82539 8.66667 3.33301 7.17428 3.33301 5.33333C3.33301 3.49238 4.82539 2 6.66634 2C8.50729 2 9.99967 3.49238 9.99967 5.33333Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
